module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/text_plan-1bd2876d2b497c70d8460fd1631a55cf.svg";